export class Dot {
  constructor({ id, x = 0, y = 0, meta = {} } = {}) {
    this.id = id;
    this.x = x;
    this.y = y;
    this.meta = meta;
  }
}
